module.exports = __webpack_public_path__ + "img/water.56fd5682.png";